<script lang="ts" setup>
  import { useConfirmDialog } from '@vueuse/core'

  import { ref } from 'vue'

  const isOpen = ref(false)

  const width = ref(500)
  const persistent = ref(false)

  const titleText = ref('')
  const messageText = ref('')

  const buttonTrueText = ref('Yes')
  const buttonFalseText = ref('No')

  const buttonTrueColor = ref('error')
  const buttonFalseColor = ref('')

  const { reveal, confirm } = useConfirmDialog()

  function open(
    title: string,
    message: string,
    options: {
      width?: number
      persistent?: boolean
      buttonTrueText?: string
      buttonTrueColor?: string
      buttonFalseText?: string
      buttonFalseColor?: string
      buttonFalseHidden?: boolean
    } = {},
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      isOpen.value = true

      titleText.value = title
      messageText.value = message

      width.value = options.width || 500
      persistent.value = options.persistent || false
      buttonTrueText.value = options.buttonTrueText ?? 'Yes'
      buttonTrueColor.value = options.buttonTrueColor || 'error'
      buttonFalseText.value = options.buttonFalseText ?? 'No'
      buttonFalseColor.value = options.buttonFalseColor || ''

      const { data } = await reveal()

      resolve(!!data)
    })
  }

  function close(confirmed: boolean) {
    confirm(confirmed)

    isOpen.value = false
  }

  defineExpose({
    open,
    isOpen,
  })
</script>

<template lang="html">
  <v-dialog
    v-model="isOpen"
    eager
    :max-width="width"
    :persistent="persistent"
    @keydown.esc="close(false)"
    @click:outside="close(false)"
  >
    <v-card>
      <v-card-title v-if="!!titleText" flat dense>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div style="word-break: normal" v-html="titleText" />
      </v-card-title>

      <v-card-text class="text-body-large py-3">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-html="messageText" />
      </v-card-text>

      <v-card-actions>
        <v-spacer />

        <v-btn v-if="!!buttonFalseText" rounded variant="text" :color="buttonFalseColor" @click="close(false)">
          {{ buttonFalseText }}
        </v-btn>
        <v-btn
          v-if="!!buttonTrueText"
          rounded
          variant="tonal"
          :color="buttonTrueColor || 'primary'"
          @click="close(true)"
        >
          {{ buttonTrueText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
